module.exports = __webpack_public_path__ + "static/scale-model-of-the-b-line-in-cincinnati-ohio-3f5380979bac014d362bdbbcfe3afea7.png";